// extracted by mini-css-extract-plugin
export var typingIndicator = "_ky-0";